import urls from "../../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../../utils/service";

export async function getRoleById(roleId?: String) {
  try {
    const callParams = await getCallParams("GET");
    if(roleId && roleId != ''){
      const response = await makeCall(
        urls.GETROLEBYID + roleId,
        callParams
      );
      return response;
    }else{
      const response = await makeCall(
        urls.GETROLE,
        callParams
      );
      return response;
    }
  } catch (error) {
    throw error;
  }
}

export async function updateRole(body: any) {
  // id from token
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEROLE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addRole(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDROLE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
